module.exports = __webpack_public_path__ + "img/WE_blog2.c4ebe777.png";